import api from '@/axios';

/**
 * Verifica o status da sessão do usuário no backend.
 * @returns {Promise<boolean>} Retorna true se a sessão for válida (status 200), false caso contrário.
 */
const verificarStatusSessao = async () => {
  // Pega o token do localStorage para verificar se ele existe.
  // Se não existir, não faz a chamada à API, economizando recursos.
  const token = localStorage.getItem('token');
  if (!token) {
    return false;
  }

  try {
    // O token é enviado automaticamente pelos interceptors do Axios.
    const response = await api.get('/auth/status');

    // Retorna true se a requisição for bem-sucedida (status 200)
    return response.status === 200;
  } catch (error) {
    console.error('Erro ao verificar status da sessão:', error.response?.data || error.message);
    // Se houver qualquer erro (401, 403, erro de rede), a sessão é considerada inválida.
    return false;
  }
};

const authService = {
  verificarStatusSessao,
};

export default authService;